/*
export const someAction = (state) => {
}
*/

import axios from 'axios'
import {API_URL} from "../../config";

// or signin in backend
export const auth = ({ commit, dispatch }, data) => {
  console.log('authing', data)
  commit('setAuthStarted', data)
  return axios.post(API_URL + '/be/user/signin', data).then(function (response) {
    console.log('auth: ', response)
    commit('setSuccesfulAuth', { response: response.data, input: data })
    // dispatch('info') //not needed
  }).catch(function (error) {
    console.log('failed', error)
    commit('setAuthFailed', { data: data, error: error.response })
  })
}

export const signup = ({ commit, dispatch }, data) => {
  console.log('signup', data)
  commit('setSignupStarted', data)
  return axios.post(API_URL + '/be/user/signup', data).then(function (response) {
    console.log('Signup: ', response)
    commit('setSuccesfulSignup', { response: response.data, input: data })
    // dispatch('auth', data)
    // dispatch('info') //not needed
  }).catch(function (error) {
    console.log('failed', error)
    commit('setSignupFailed', { data: data, error: error.response })
  })
}

export const PasswordForget = ({ commit, dispatch }, data) => {
  console.log('signup', data)
  commit('setPasswordForgetStarted', data)
  return axios.post(API_URL + '/be/user/password_forget', data).then(function (response) {
    console.log('PasswordForget: ', response)
    commit('setSuccesfulPasswordForget', { response: response.data, input: data })
  }).catch(function (error) {
    console.log('failed', error)
    commit('setPasswordForgetFailed', { data: data, error: error.response })
  })
}

// not needed everything is send by the signin msg
export const info = ({ commit, state }, data) => {
  console.log('fetching me', data)
  commit('setAuthStarted')
  return axios.get(API_URL + 'me').then(function (response) {
    console.log('me data: ', response.data)
    commit('setMe', response.data)
  }).catch(function (res) {
    console.log(res)
    commit('resetMe')
  })
}

export const setpw = ({ commit, dispatch }, data) => {
  console.log('set pasword', data)
  commit('setPWStarted', data)
  return axios.post(API_URL + '/be/user/user_change_password', data).then(function (response) {
    console.log('setpw: ', response)
    commit('setPWSuccess', { response: response.data, input: data })
  }).catch(function (error) {
    console.log('failed', error, error.response)
    commit('setPWFailed', { data: data, error: error.response })
  })
}
